import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { DialogPosition } from './types'

export const getDialogPositionPoints = (
  position: DialogPosition,
  x: number,
  y: number,
  delta: { x: number; y: number },
) => {
  // delta.x > 0 means movement to the right
  // delta.y > 0 means movement downward

  switch (position) {
    case 'right-top':
      // right decreases when moving right, top increases when moving down
      return {
        x: x - delta.x,
        y: y + delta.y,
      }
    case 'right-bottom':
      // right decreases when moving right, bottom decreases when moving down
      return {
        x: x - delta.x,
        y: y - delta.y,
      }
    case 'left-top':
      // left increases when moving right, top increases when moving down
      return {
        x: x + delta.x,
        y: y + delta.y,
      }
    case 'left-bottom':
      // left increases when moving right, bottom decreases when moving down
      return {
        x: x + delta.x,
        y: y - delta.y,
      }
  }
}

export const getPositionStyles = (position: DialogPosition, x: number, y: number) => {
  const baseStyles: Record<string, string> = {
    position: 'fixed',
    boxShadow: 'unset',
    backgroundColor: 'transparent',
    margin: '0',
    overflow: 'hidden',
  }

  switch (position) {
    case 'left-top':
      return {
        ...baseStyles,
        left: `${x}px`,
        top: `${y}px`,
        right: 'unset',
        bottom: 'unset',
      }
    case 'left-bottom':
      return {
        ...baseStyles,
        left: `${x}px`,
        bottom: `${y}px`,
        right: 'unset',
        top: 'unset',
      }
    case 'right-top':
      return {
        ...baseStyles,
        right: `${x}px`,
        top: `${y}px`,
        left: 'unset',
        bottom: 'unset',
      }
    case 'right-bottom':
      return {
        ...baseStyles,
        right: `${x}px`,
        bottom: `${y}px`,
        left: 'unset',
        top: 'unset',
      }
  }
}

// Checks if the element or its parents have the data-drag-handle="true" attribute
export const hasDragHandle = (target: EventTarget | null): boolean => {
  // Check for Element (includes HTMLElement, SVGElement, etc.)
  // TextNode and other non-Element nodes don't have closest method
  if (!target || !(target instanceof Element)) return false
  return !!target.closest('[data-drag-handle="true"]')
}

// Creates custom listeners that allow drag only with elements, that have the data-drag-handle="true" attribute
export const createDragHandleListeners = (
  listeners: SyntheticListenerMap,
  requireDragHandle: boolean,
): SyntheticListenerMap => {
  if (!requireDragHandle || !listeners) {
    return listeners
  }

  return {
    ...listeners,
    onMouseDown: (e: React.MouseEvent) => {
      if (!hasDragHandle(e.target)) {
        e.stopPropagation()
        return
      }
      listeners.onMouseDown?.(e as any)
    },
    onTouchStart: (e: React.TouchEvent) => {
      if (!hasDragHandle(e.target)) {
        e.stopPropagation()
        return
      }
      listeners.onTouchStart?.(e as any)
    },
    onKeyDown: (e: React.KeyboardEvent) => {
      if (!hasDragHandle(e.target)) {
        e.stopPropagation()
        return
      }
      listeners.onKeyDown?.(e as any)
    },
  }
}
